import { LoadingButton } from "@mui/lab";
import { Button, Card, CardContent, CardHeader, Grid, Box } from "@mui/material"
import { useEffect, useState } from "react";
import DownloadSampleFile from "../../components/DownloadSampleFile";
import UploadIcon from '@mui/icons-material/Upload';
import { FormProvider, RHFFileField, RHFTextField, } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { apiConstants, postGeneric, postMultipart } from "../../common/constants";
import { useSnackbar } from "notistack";
import PageTitle from "../../components/PageTitle";
import MUIModal from "../../components/MuiModal";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';

function WeightFreezeUpload() {
    const { enqueueSnackbar } = useSnackbar();
    const [isSubmitting, setIsSubmitting] = useState(false)
    const sampleName = "WEIGHT_FREEZE";
    const [open, setOpen] = useState(false)


    const methods = useForm()

    const { handleSubmit, reset } = methods

    const onSubmit = async (data) => {
        setIsSubmitting(true)
        let formData = new FormData()
        formData.append('file', data?.file[0])
        delete data.file
        try {
            await postMultipart(apiConstants.WEIGHT_FREEZE, formData).then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar('Successfully uploaded!', { variant: 'success' })
                    reset()
                }
                else {
                    enqueueSnackbar(`${res.data}`, { variant: 'error' })
                    reset()
                }
            })
            reset()
        } catch (err) {
            const message = err.response?.data?.message || err.message
            enqueueSnackbar(message, { variant: 'error' })
        }

        setIsSubmitting(false)
    }


    useEffect(() => {
        const payload = {
            "collection": "weight_freeze",
            limit: 10000
        }
        postGeneric(apiConstants.REPORT_GENERIC_SEARCH, payload).then((res) => {
            console.log(res, 'res')
        }).catch((err) => {
            // setLoading(false)
            // setData(res?.data?.data)
            // console.log(err)
            // setLoading(false)
        })
    }, [])


    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <PageTitle>Courier Weight Freeze</PageTitle>
            {/* <Box sx={{
                width: 1,
                boxShadow: 1,
                backgroundColor: "#fff",
                p: 2
            }}> */}
            <Card>
                <CardHeader title='Courier Weight Freeze Upload' action={
                    <Grid sx={{ padding: 2, display: 'flex', justifyContent: 'end' }}>
                        <Button variant='contained' color='warning' startIcon={<AddCircleOutlineIcon />} sx={{ boxShadow: 0 }}
                            onClick={() => handleOpen()}> Add Single SKU</Button>
                    </Grid>
                }
                />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <RHFFileField name='file' />
                            </Grid>

                            <Grid item xs={12}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="medium"
                                    startIcon={<UploadIcon />}
                                    type="submit"
                                    sx={{mr:2}}
                                >
                                    Upload
                                </LoadingButton>
                                <DownloadSampleFile fileName={sampleName} />
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <MUIModal open={open} handleClose={handleClose} children=
                {
                    <AddSKU setOpen={setOpen} handleClose={handleClose} open={open} />
                }
                title={"Single SKU Update"} maxWidth="lg"
            />
            {/* </Box> */}
        </>
    )
}

export default WeightFreezeUpload;



const AddSKU = ({ setOpen, handleClose, reload, open }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isSubmitting, setIsSubmitting] = useState(false)

    const methods = useForm({
        resolver: yupResolver(Yup.object().shape({
            merchant: Yup.string().required("Please Select the Merchant"),
            sku: Yup.string().required("Please provide SKU detail"),
            weight: Yup.string().required("Please provide weight"),
            skuDesc: Yup.string().required("Please provide Sku Description"),
            length: Yup.string().required("Please provide length"),
            breadth: Yup.string().required("Please provide breadth"),
            height: Yup.string().required("Please provide height"),
        })),
        defaultValues: {
            merchant: '',
            sku: '',
            weight: '',
            length: '',
            breadth: '',
            height: ''
        }
    });
    const { handleSubmit } = methods

    const onSubmit = (data) => {
        setIsSubmitting(true)
            const request = {
            sku: data.sku,
            skuDesc: data.skuDesc,
            length: data.length,
            breadth: data.breadth,
            height: data.height,
            weight: data.weight,
            images: [
                data.image1,
                data.image2,
                data.image3,
                data.image4,
                data.image5,
                data.image6
            ].filter(image => image && image.trim() !== '')
        }
        postGeneric(`${apiConstants.GET_SKU}/sku/${data.merchant}`, request).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar('SKU update successfully', { variant: 'success' })
                setOpen(false);
                // setReload(() => reload + 1)
            }
            else {
                enqueueSnackbar("SKU is not Created", { variant: 'error' })
            }
        }).catch((err) => console.log(err))
        setIsSubmitting(false)
    }



    return (
        <Card>
            <CardContent>
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <MerchantFilterCached />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFTextField name='sku' label='SKU' width='100%' />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFTextField name='weight' label='Weight in gm' width='100%' />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFTextField name='length' label='Length in cm' width='100%' />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFTextField name='breadth' label='Breadth in cm' width='100%' />
                        </Grid>
                        <Grid item xs={4}>
                            <RHFTextField name='height' label='Height in cm' width='100%' />
                        </Grid>
                        <Grid item xs={6}>
                            <RHFTextField name='skuDesc' label='Sku Description' width='100%' multiline />
                        </Grid>
                        <Grid item xs={6}>
                            <Accordion sx={{ 
                                '& .MuiAccordionSummary-root': {
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px 4px 0 0',
                                },
                                '& .MuiAccordionDetails-root': {
                                    padding: '16px',
                                    maxHeight: '280px',
                                    overflowY: 'auto',
                                }
                            }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <Typography 
                                        color='primary' 
                                        sx={{ 
                                            fontWeight: 500,
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        Upload Images
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {[1, 2, 3, 4, 5, 6].map((num) => (
                                        <Box key={num} sx={{ mb: 2 }}>
                                            <Typography 
                                                sx={{ 
                                                    mb: 1,
                                                    color: 'text.secondary',
                                                    fontSize: '0.875rem'
                                                }}
                                            >
                                                Image URL {num}:
                                            </Typography>
                                            <RHFTextField 
                                                name={`image${num}`} 
                                                label='Image URL' 
                                                fullWidth
                                                size="small"
                                            />
                                        </Box>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'left' }}>
                            <LoadingButton
                                loading={isSubmitting}
                                type='submit'
                                variant="contained">
                                Submit
                            </LoadingButton>
                        </Grid>

                    </Grid>
                </FormProvider>
            </CardContent>
        </Card>
    )
}
